export default "__VITE_ASSET__DZyA8QA2__"